import { Component, OnInit } from '@angular/core';
import { AutomationService } from '../automation.service';
import { AutomationMapFormatTransformService } from '../automation-map-format-transform.service';

@Component({
  selector: 'app-map-format-transform',
  templateUrl: './map-format-transform-s3.component.html',
  styleUrls: ['./map-format-transform-s3.component.css']
})
export class MapFormatTransformS3Component implements OnInit {

  inputMap = "https://iohsbsharebucket.s3.amazonaws.com/MapTransform/mapIn/hsbExporter.dxx";
  outputMap = "https://iohsbsharebucket.s3.amazonaws.com/MapTransform/mapOut/hsbExporter.hmm";

  accessKeyId = "AKIAIMVKNEIZGS4LP7KQ";
  secretAccessKey = "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";

  showSpinner = false;

  result = "";

  constructor(private automationService: AutomationService,
              private automationMapFormatTransformService: AutomationMapFormatTransformService) { }

  ngOnInit() {
  }

  run(){

    this.result = ""
    this.showSpinner = true;

    let executionContext = this.automationMapFormatTransformService.
                            getExecutionContextDefaultCopy(this.inputMap,
                              this.outputMap,
                              this.accessKeyId,
                              this.secretAccessKey);

    this.automationService.executeContext(executionContext)
      .then(result => {
          this.showSpinner = false;
          this.result = JSON.stringify(result);
      }, error => {
          this.showSpinner = false;
          this.result = "Error: " + JSON.stringify(error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/map-format-transform-s3/map-format-transform-s3.component.ts